import cloneDeep from 'lodash.clonedeep';
/**
 * Helper function to generate JSON Schemas with some excluded fields, based on the original entity schema.
 * @param schema
 * @param excludeProps
 * @param optionalProps
 * @returns {JSONSchema4}
 */
export const schemaWithoutProps = (schema, excludeProps, optionalProps) => {
    // Create a copy so we do not modify the original schema
    const schemaCopy = cloneDeep(schema);
    // Remove custom title as we want to maintain the naming convention for request and response schemas.
    delete schemaCopy.title;
    // TODO should cleanup this key in future migration
    delete schemaCopy.properties?.__v;
    for (const excludedProp of excludeProps) {
        delete schemaCopy.properties[excludedProp];
    }
    for (const all of schemaCopy.allOf ?? []) {
        for (const excludedProp of excludeProps) {
            delete all.properties[excludedProp];
        }
    }
    const required = schemaCopy.required.filter((prop) => !excludeProps.includes(prop) && !optionalProps.includes(prop));
    return { ...schemaCopy, required };
};
//# sourceMappingURL=schemaWithoutProps.js.map